import React from 'react';
const PreloadImages = ({ images }) => (React.createElement("div", { style: { display: 'none' } }, images.map((image, i) => (React.createElement("img", { key: i, src: image, alt: "" })))));
export default PreloadImages;
